import * as React from "react";
import { CaseRunClient } from "@app/api2/api";
import { Table, TableBody, TableCell, TableHeader, TableHeaderCell, TableRow } from "@/components/bp/bp-ui";

export class SentryMatchHitDetails extends React.Component<{ resultId: string; labId: number; caseId: number; caseRunId: number; }, { data: Array<any>; }> {
    client = new CaseRunClient();

    constructor(props) {
        super(props);
        this.state = { data: [] };
    }

    async componentDidMount() {
        let results = await this.client.getSentryResultDetail(this.props.labId, this.props.caseId, this.props.caseRunId, this.props.resultId);
        this.setState({ data: results });
    }

    render() {
        return (
            <div className="widetable">
                <Table definition className="sentry-hits-details">
                    <TableHeader>
                        <TableRow>
                            <TableHeaderCell />
                            <TableHeaderCell colSpan={2} style={{ whiteSpace: 'normal' }}>{window.translation.common.reference}</TableHeaderCell>
                            <TableHeaderCell colSpan={3} />
                            <TableHeaderCell colSpan={10} style={{ whiteSpace: 'normal' }}>{window.translation.common.evidence}</TableHeaderCell>
                        </TableRow>
                        <TableRow>
                            <TableHeaderCell></TableHeaderCell>
                            <TableHeaderCell>Al1</TableHeaderCell>
                            <TableHeaderCell>Al2</TableHeaderCell>
                            <TableHeaderCell className="lr">LR</TableHeaderCell>
                            <TableHeaderCell>LR 2P</TableHeaderCell>
                            <TableHeaderCell className="lr">Hp Penalty</TableHeaderCell>
                            {[...Array(20).keys()].map(x => {
                                return (
                                    <TableHeaderCell key={`cl${x}`}>{`Al${x + 1}`}</TableHeaderCell>
                                )
                            })}
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {(this.state.data).map((m, i) => (
                            <TableRow key={m.locus} className={`${m.isCommon ? 'is-common' : ''} ${m.hasMatch ? 'has-match' : ''} ${m.hasFullMatch ? 'has-full-match' : ''} `}>
                                <TableCell>
                                    {m.locus}
                                </TableCell>
                                <TableCell>
                                    {m.refAllele1}
                                </TableCell>
                                <TableCell>
                                    {m.refAllele2}
                                </TableCell>
                                <TableCell className="lr">
                                    {m.lr.toExponential(5)}
                                </TableCell>
                                <TableCell className="lr">
                                    {m.lr2P.toExponential(5)}
                                </TableCell>
                                <TableCell className="lr">
                                    {m.hpPenalty.toExponential(5)}
                                </TableCell>
                                {[...Array(20).keys()].map(x => {
                                    return (
                                        <TableCell key={`cl${x}`}>
                                            {m['evAllele' + (x + 1)]}
                                        </TableCell>
                                    )
                                })}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </div>
        );
    }
}
